<script>
export default {
    name: 'Deal',
    props: {
        completed: Boolean,
    },
}
</script>

<template lang="pug">
.deal
    transition(name="fade")
        h4.d-flex.align-items-start.text-primary(v-if="completed")
            icon.mr-2(icon="fa-solid fa-check-circle" :key="completed")
            slot(name="completed")
        h4.d-flex.align-items-start.text-26(v-else)
            icon.text-99.mr-2(icon="fa-regular fa-check-circle" :key="completed")
            slot(name="deal")
</template>
